import { planActionTypes, userActionTypes } from '../actions/types';
import { planService } from '../services';
import _ from 'lodash';

const _refreshTokenOnFailure = (error, failureAction, pendingRefreshToken) => {
    if (error.error === 'jwt expired') {
        if (pendingRefreshToken) {
            return {
                type: userActionTypes.PENDING_REFRESH_TOKEN,
                error,
            };
        } else {
            return { type: userActionTypes.INVALID_TOKEN, error };
        }
    } else {
        return { type: failureAction, error };
    }
};

function getAll(query) {
    return (dispatch, getState) => {
        dispatch(request());

        planService.getPlans(query).then(
            plans => {
                dispatch(success(plans))
            },
            error => dispatch(failure(error, getState().authentication.pendingRefreshingToken)),
        );
    };

    function request() {
        return { type: planActionTypes.GETALL_REQUEST };
    }
    function success(plans) {
        return { type: planActionTypes.GETALL_SUCCESS, plans };
    }
    function failure(error, pendingRefreshToken) {
        if (error.code === 'invalidToken') {
            if (pendingRefreshToken) {
                return {
                    type: userActionTypes.PENDING_REFRESH_TOKEN,
                    error: error.error,
                };
            } else {
                return { type: userActionTypes.INVALID_TOKEN, error: error.error };
            }
        } else {
            return { type: planActionTypes.GETALL_FAILURE, error: error.error };
        }
    }
}

const create = (plan) => {
    return (dispatch, getState) => {
        dispatch(request());

        planService.create(plan).then(
            plan => {
                dispatch(success(plan));
            },
            error => {
                dispatch(
                    _refreshTokenOnFailure(
                        error,
                        planActionTypes.CREATE_FAILURE,
                        getState().authentication.pendingRefreshingToken,
                    ),
                );
            },
        );
    };

    function request() {
        return { type: planActionTypes.CREATE_REQUEST };
    }
    function success(plan) {
        return { type: planActionTypes.CREATE_SUCCESS, plan };
    }
}

const update = (plan) => {
    return (dispatch, getState) => {
        dispatch(request());

        planService.update(plan).then(
            plan => {
                dispatch(success(plan));
            },
            error => {
                dispatch(
                    _refreshTokenOnFailure(
                        error,
                        planActionTypes.UPDATE_FAILURE,
                        getState().authentication.pendingRefreshingToken,
                    ),
                );
            },
        );
    };

    function request() {
        return { type: planActionTypes.UPDATE_REQUEST };
    }
    function success(plan) {
        return { type: planActionTypes.UPDATE_SUCCESS, plan };
    }
}

export const planActions = {
    getAll,
    create,
    update,
};